var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 17.5536 39.5599 15.2101 38.756 13.0436L20 12.174L1.24398 13.0435C0.440078 15.2101 0 17.5536 0 20C0 22.4464 0.440078 24.79 1.24398 26.9565L20 27.8261L38.756 26.9566C39.5599 24.79 40 22.4464 40 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C28.5992 40 35.9301 34.5725 38.7559 26.9565H1.2439C4.06976 34.5725 11.4006 40 19.9999 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2439 13.0435H38.756C35.9301 5.4275 28.5992 0 19.9999 0C11.4006 0 4.06976 5.4275 1.2439 13.0435V13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 13.9131H21.739L22.3188 9.56525L24.6375 7.82611L26.9564 9.56525V13.0435L25.2173 13.9131Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7824 13.9131H18.2607L17.6809 9.56525L15.3621 7.82611L13.0433 9.56525V13.0435L14.7824 13.9131Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3188 13.9131H17.681V9.56525L19.9999 7.82611L22.3188 9.56525V13.9131Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 13.0436V22.6087C13.0435 24.8863 14.1436 26.9118 15.8405 28.1815L17.0579 27.8769L18.5942 29.4224C19.0485 29.516 19.5185 29.5653 20 29.5653C20.4789 29.5653 20.9467 29.5166 21.3985 29.424L23.1522 27.9638L24.1594 28.1787C25.8556 26.909 26.9565 24.8857 26.9565 22.6087V13.0436H13.0435Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0433 13.0435H15.8259V15.8261H13.0433V13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6084 13.0435H21.391V15.8261H18.6084V13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1737 13.0435H26.9563V15.8261H24.1737V13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8259 15.826H18.6085V18.6086H15.8259V15.826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3912 15.826H24.1738V18.6086H21.3912V15.826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0433 18.6078H15.8259V21.3904H13.0433V18.6078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8259 21.3904H18.6085V24.173H15.8259V21.3904Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6084 18.6078H21.391V21.3904H18.6084V18.6078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1737 18.6078H26.9563V21.3904H24.1737V18.6078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3912 21.3904H24.1738V24.173H21.3912V21.3904Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6084 24.1731H21.391V26.9557H18.6084V24.1731Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.826 24.1733H13.2229C13.4617 25.2077 13.931 26.1541 14.5746 26.9559H15.826V24.1733Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1737 26.9559H25.425C26.0687 26.1542 26.5379 25.2076 26.7767 24.1733H24.1737V26.9559Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8259 26.9559V28.1701C16.6352 28.7791 17.581 29.2157 18.6085 29.4252V26.9559H15.8259Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3912 26.9559V29.4252C22.4188 29.2159 23.3645 28.7791 24.1738 28.1701V26.9559H21.3912Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/croatia.4726bf62a617ab506099a50e0103b150.svg";
export { ForwardRef as ReactComponent };